import React, { useState } from 'react';
import './App.css';
import ScimitarLogo from './components/ScimitarLogo';
import ContactModal from './components/ContactModal';

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-section">
              <ScimitarLogo />
              <h1 className="company-name">Scimitar</h1>
            </div>
            <button className="contact-button" onClick={openContactModal}>
              Contact
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h2 className="hero-title">
              Intelligence Artificielle
            </h2>
            <p className="hero-subtitle">
              Solutions d'infrastructure données IA de nouvelle génération pour l'entreprise
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="main-content">
        <div className="container">
          <section className="services-section">
            <div className="service-block">
              <h3>IA.autonome</h3>
              <p>
                Nos systèmes d'intelligence artificielle autonome révolutionnent l'infrastructure 
                de données avec des algorithmes auto-évolutifs. L'automatisation native pilotée 
                par l'IA transforme vos écosystèmes complexes en solutions intelligentes et 
                adaptatives à l'échelle institutionnelle.
              </p>
            </div>

            <div className="service-block">
              <h3>cloud.native</h3>
              <p>
                Architectures cloud-native de nouvelle génération avec décomposition topologique 
                intelligente des systèmes legacy. Nos modèles de référence formellement définis 
                et l'évolution de schéma automatisée créent des infrastructures conteneurisées 
                auto-optimisantes.
              </p>
            </div>

            <div className="service-block">
              <h3>data.mesh</h3>
              <p>
                Pipelines de données intelligents avec harmonisation transparente multi-domaines. 
                Notre mesh de données préserve l'intégrité structurelle tout en permettant une 
                évolutivité continue et une orchestration automatisée de vos flux d'information.
              </p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <p>&copy; 2024 Scimitar. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      {isContactModalOpen && (
        <ContactModal onClose={closeContactModal} />
      )}
    </div>
  );
}

export default App; 